import { useEffect, useState } from 'react';
import HeavyHeader from '../../components/heavy-header/heavy-header';
import './kpi-user.css';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import * as XLSX from "xlsx";
import { saveAs } from 'file-saver';
import { FaX } from "react-icons/fa6";

function KpiUserCP () {
  const [usersData, setUsersData] = useState(['init']);
  const [currentTime, setCurrentTime] = useState([]);
  const [currentPlatform, setCurentPlatform] = useState([]);
  const [currentSession, setCurrentSession] = useState([]);
  const [currentCounter, setCurrentCounter] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [filenameData, setFileNameData] = useState("");
  const [statusModal, setStatusModal] = useState({ status: false, modal: "" });
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: 'onChange'
  });

  useEffect(() => {
    setValue('selectDate', getToday())
  }, [setValue]);

  const getToday = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  }

  const formatDateToDDMMYYYY = (isoDate) => {
    const [year, month, day] = isoDate.split('-');
    return `${day}/${month}/${year}`;
  };

  const handleDate = async (data) => {
    setShowLoader(true);
    const formatData = formatDateToDDMMYYYY(data.selectDate)
    setFileNameData(formatData);
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/user/kpis?today=${formatData}`
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
        },
      });
      setUsersData(response.data.data);
      setShowLoader(false)
    } catch (error) {
      console.error(error);
    }
  }

  const exportToExcel = () => {
    const filteredData = usersData.map(user => {
      const { sessions, time_paused, counter_checkouts, ...rest } = user;

      const formattedSessions = sessions.map((session, index) => {
        return `Perfil: ${sesionProfileText(session.profile) || 'NA'} - Login: ${session.login || 'NA'} - Logout: ${session.logout || 'NA'} - Duración: ${session.duration || 'NA'}`;
      }).join('\n');

      const formattedCounter = counter_checkouts.map((counter, index) => {
        return `Checkout mostrador: ${counter.counter_checkout || 'NA'}, - Fecha inicio: ${counter.date_start || 'NA'} - Fecha final: ${counter.date_finish || 'NA'}`;
      }).join('\n');

      const formattedTime = time_paused.map((time, index) => {
        return `Checkout mostrador: ${time.counter_checkout || 'NA'} - Fecha inicio: ${time.date_start || 'NA'} - Fecha final: ${time.date_finish} - Tiempo total ${time.total_time}`;
      }).join('\n');

      const showPlatforms = `Tarimas correctas: ${rest.inpector.pallet_correct} \n Tarimas incorrectas: ${rest.inpector.pallet_incorrect}`;

      return {
        "# Login": rest.numer_login,
        "Sesión activa": rest.sessions_active,
        "Sesión pausada": rest.time_pause_total,
        "# Turnos asignados": rest.turn_assing,
        "# Turnos reasignados": rest.turn_reassing,
        "# Turnos transferidos": rest.turn_trasnfer,
        "ID usuario": rest.user_id,
        "Usuario": rest.user_name,
        "Sesión": formattedSessions,
        "Mostrador de cajas": formattedCounter,
        "Tiempo pausado": formattedTime,
        "Mostrador de Tarimas": showPlatforms
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Usuarios");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(blob, `usuarios-${filenameData}.xlsx`);
  }

  const sesionProfileText = (id) => {
    switch (id) {
      case 1:
        return "Colocador";
      case 2:
        return "Pesador";
      case 3:
        return "Documentador";
      case 4:
        return "Pantalla de turnos";
      case 5:
        return "Inspector";
      case 6:
        return "Turnos";
      case 7:
        return "Reimprimir Turnos";
      case 8:
        return "Administrador";
      case 9:
        return "Kpi Usuario";
      default:
        return "";
    }
  }

  const handleModalClick = (event) => {
    event.stopPropagation();
  };

  const resetUserData = () => {
    setCurrentTime([]);
    setCurrentSession([]);
    setCurrentCounter([]);
    setCurentPlatform([]);
  }

  const renderCounter = () => {
    return (
      <div className='kpi-modal' onClick={handleModalClick}>
        
        <div className='kpi-header-modal'>
          <h4>Mostrador de cajas</h4>
          <FaX 
            style={{ color: "#dc0f38", cursor: "pointer" }} 
            onClick={() => {
              setStatusModal({ status: false, modal: "" });
              resetUserData()
            }}
          />
        </div>

        <div className='kpi-body-modal'>
          <table className='kpi-table'>
            <thead>
              <tr>
                <th>Checkout mostrador</th>
                <th>Fecha inicio</th>
                <th>Fecha final</th>
              </tr>
            </thead>
            <tbody>
              {currentCounter.map((counter, index) => (
                <tr key={`counter_${index}`}>
                  <td>{ counter.counter_checkout }</td>
                  <td>{ counter.date_start }</td>
                  <td>{ counter.date_finish }</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    )
  }

  const renderSesion = () => {
    return (
      <div className='kpi-modal' onClick={handleModalClick}>
        
        <div className='kpi-header-modal'>
          <h4>Tiempo de sesión</h4>
          <FaX 
            style={{ color: "#dc0f38", cursor: "pointer" }} 
            onClick={() => {
              setStatusModal({ status: false, modal: "" });
              resetUserData()
            }}
          />
        </div>

        <div className='kpi-body-modal'>
          <table className='kpi-table'>
            <thead>
              <tr>
                <th>Perfil</th>
                <th>Login</th>
                <th>Logout</th>
                <th>Duración</th>
              </tr>
            </thead>
            <tbody>
              {currentSession.map((session, index) => (
                <tr key={`session_${index}`}>
                  <td>{ sesionProfileText(session.profile) }</td>
                  <td>{ session.login }</td>
                  <td>{ session.logout }</td>
                  <td>{ session.duration }</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    )
  }

  const renderTime = () => {
    return (
      <div className='kpi-modal' onClick={handleModalClick}>
        
        <div className='kpi-header-modal'>
          <h4>Tiempo Pausado</h4>
          <FaX 
            style={{ color: "#dc0f38", cursor: "pointer" }} 
            onClick={() => {
              setStatusModal({ status: false, modal: "" });
              resetUserData()
            }}
          />
        </div>

        <div className='kpi-body-modal'>
          <table className='kpi-table'>
            <thead>
              <tr>
                <th>Checkout mostrador</th>
                <th>Fecha inicio</th>
                <th>Fecha final</th>
                <th>Tiempo total</th>
              </tr>
            </thead>
            <tbody>
              {currentTime.map((time, index) => (
                <tr key={`time_${index}`}>
                  <td>{ time.counter_checkout }</td>
                  <td>{ time.date_start }</td>
                  <td>{ time.date_finish }</td>
                  <td>{ time.total_time }</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    )
  }

  const renderPlatform = () => {
    return (
      <div className='kpi-modal' onClick={handleModalClick}>
        
        <div className='kpi-header-modal'>
          <h4>Mostrador de tarimas</h4>
          <FaX 
            style={{ color: "#dc0f38", cursor: "pointer" }} 
            onClick={() => {
              setStatusModal({ status: false, modal: "" });
              resetUserData()
            }}
          />
        </div>

        <div className='kpi-body-modal'>
          <table className='kpi-table'>
            <thead>
              <tr>
                <th>Tarimas correctas</th>
                <th>Tarimas incorrectas</th>
              </tr>
            </thead>
            <tbody>
              <tr key={`platform`}>
                <td>{ currentPlatform.pallet_correct }</td>
                <td>{ currentPlatform.pallet_incorrect }</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    )
  }
  
  return (
    <>
      <div className='body-kpi'>
        <HeavyHeader />
        
        <form onSubmit={handleSubmit(handleDate)} className='kpi-form'>
          <div className='kpi-input-cont'>
            <label htmlFor='selectDate'>Seleccionar fecha</label>
            <input 
              type='date'
              id='selectDate'
              {...register("selectDate", {
                required: true
              })}
            />
            {errors.selectDate && <span className='error-kpi'>La fecha es requerida</span>}
          </div>

          <button type='submit' className='btn-blue'>Buscar</button>
          {(usersData.length > 0 && usersData[0] !== 'init' && !showLoader) && <button type='button' className='btn-blue' onClick={exportToExcel}>Exportar</button>}
        </form>


        {showLoader && <span className="kpi-loader"></span>}

        {(usersData.length > 0 && usersData[0] !== 'init' && !showLoader) && <div className='kpi-table-container'>
          <table className='kpi-table'>
            <thead>
              <tr>
                <th># Login</th>
                <th>Sesión activa</th>
                <th>Tiempo pausado</th>
                <th># Turnos asignados</th>
                <th># Turnos reasignados</th>
                <th># Turnos transferidos</th>
                <th>ID usuario</th>
                <th>Usuario</th>
                <th>Mostrador de cajas</th>
                <th>Sesión</th>
                <th>Tiempo pausado</th>
                <th>Mostrador de tarimas</th>
              </tr>
            </thead>
            <tbody>
              {usersData.map((user, index) => (
                <tr key={index}>
                  <td>{ user.numer_login }</td>
                  <td>{ user.sessions_active }</td>
                  <td>{ user.time_pause_total }</td>
                  <td>{ user.turn_assing }</td>
                  <td>{ user.turn_reassing }</td>
                  <td>{ user.turn_trasnfer }</td>
                  <td>{ user.user_id }</td>
                  <td>{ user.user_name }</td>
                  <td>
                    <button 
                      className='btn-blue btn-info' 
                      onClick={() => {
                        setStatusModal({status: true, modal: "counter"});
                        setCurrentCounter(user.counter_checkouts);
                      }}
                    >
                      ver información
                    </button>
                  </td>
                  <td>
                    <button 
                      className='btn-blue btn-info' 
                      onClick={() => {
                        setStatusModal({status: true, modal: "sesion"});
                        setCurrentSession(user.sessions)
                      }}
                    >
                      ver información
                    </button>
                  </td>
                  <td>
                    <button 
                      className='btn-blue btn-info' 
                      onClick={() => {
                        setStatusModal({status: true, modal: "time"});
                        setCurrentTime(user.time_paused);
                      }}
                    >
                      ver información
                    </button>
                  </td>
                  <td>
                    <button 
                      className='btn-blue btn-info' 
                      onClick={() => {
                        setStatusModal({status: true, modal: "platform"});
                        setCurentPlatform(user.inpector);
                      }}
                    >
                      ver información
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>}

        {(usersData.length === 0 && !showLoader) &&
          <h4 className='kpi-not-found'>No se encontraron registros</h4>
        }

        {/* MODALS WINDOW */}
        <div 
          className={`kpi-modal-bg ${statusModal.status ? 'active' : ''}`} 
          onClick={() => {
            setStatusModal({ status: false, modal: "" });
            resetUserData();
          }}
        >
          {(statusModal.status && statusModal.modal === "counter") && renderCounter()}

          {(statusModal.status && statusModal.modal === "sesion") && renderSesion()}

          {(statusModal.status && statusModal.modal === "time") && renderTime()}

          {(statusModal.status && statusModal.modal === "platform") && renderPlatform()}
        </div>

      </div>
    </>
  )
}

export default KpiUserCP;